import type { RouteObject } from 'react-router-dom';
import { Navigate } from 'react-router-dom';

import { CategoriesPage } from './ui/pages/CategoriesPage';
import { ImportPage } from './ui/pages/ImportPage';
import { PricingPage } from './ui/pages/PricingPage';
import { ProductEditPage } from './ui/pages/ProductEditPage';
import { ProductsPage } from './ui/pages/ProductsPage';

/**
 * Catalog feature subtree, mounted under the authenticated `AppLayout` shell.
 * `/catalog` redirects to the products workspace. The static `products/new`
 * route is ranked above the dynamic `products/:productId` editor by react-router.
 */
export const catalogRoutes: RouteObject = {
  path: 'catalog',
  children: [
    { index: true, element: <Navigate to="/catalog/products" replace /> },
    { path: 'products', element: <ProductsPage /> },
    { path: 'products/new', element: <ProductEditPage /> },
    { path: 'products/:productId', element: <ProductEditPage /> },
    { path: 'categories', element: <CategoriesPage /> },
    { path: 'pricing', element: <PricingPage /> },
    { path: 'import', element: <ImportPage /> },
    { path: '*', element: <Navigate to="/catalog/products" replace /> },
  ],
};
